<template>
    <div class="page-content order_content">
        <div class="warp1200">

            <!-- 航线信息 -->
            <div class="line_con">
                <div class="line_info_con">
                    <div class="ship_way">
                        {{campaign.campaignName}}
                        <a id="opbkRuleLink" @click="isShowRulePopup=true"><span>活动规则</span><img class="det_icon" src="https://resource.rcclchina.com.cn/tui2/info/webhao.png"></a>
                    </div>
                    <div class="ship_time">
                        {{campaign.campaignSubTitle}}
                    </div>
                    
                </div>
            </div>

            <!-- 订单信息 -->
            <div class="order_con">
                <div class="order_info_con">
                    <span v-if="!campaign.isSendCoupon">
                        <span style="font-size: 16px;">船票预订号：</span>
                        <span class="info_text fw-400">{{pageData.bookingId || '48小时内生成' }}</span>
                    </span>
                    <div class="or_stu" :class="{'or_stu_unpay': pageData.openBookingStatus == 0, 'or_stu_paid': pageData.openBookingStatus > 0}">
                        <span class="ft_12 fw-400">{{statusName}}</span>
                    </div>
                    <div v-if="isSendGift" class="go-gift">
                        <a :href="giftLink">查看礼品</a>
                    </div>

                </div>
                <div class="room_con">
                    <div class="usr_con">
                        <div class="usr_head_con">
                            <div class="usr_head">
                                <span class="fw-400">
                                    <span>{{pageData.lastName + pageData.firstName}} {{pageData.lastNamePinyin + " " + pageData.firstNamePinyin}} </span>
                                </span>

                            </div>
                            <div class="head_rg">
                                费用明细
                            </div>

                        </div>
                        <div class="info_con">
                            <div class="info_lf">
                                <div class="det_lf">
                                    <div>性别：<span class="text fw-400">{{pageData.gender == 'F' ? '女': '男'}}</span></div>
                                    <div>生日：<span class="text fw-400">{{pageData.dateOfBirth}}</span></div>
                                    <div>手机：<span class="text fw-400">{{pageData.telephone}}</span></div>
                                </div>
                                <div class="det_lf det_rg">
                                    <div>国籍：<span class="text fw-400">{{pageData.nationalityName}}</span></div>
                                    <div>邮箱：<span class="text fw-400">{{pageData.email}}</span></div>
                                </div>
                            </div>
                            <div class="info_rg">
                                <div class="price_con">
                                    <div>订金总额<span class="text fw-400">￥{{pageData.amount}}</span></div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- 选择支付方式 -->
            <div v-if="pageData.openBookingStatus == 0 && !isExpired">
                <div class="line_con choose_pay_con" style="margin-bottom: 0" >
                    <div class="pay_title">选择支付方式</div>
                    <div class="pay_way_con">
                        <div class="pay_way_item canSelect" :class="{ active: paymentType == 'ALIPAY'}" @click="paymentType='ALIPAY'">
                            <img src=" https://resource.rcclchina.com.cn/tui2/order/alipay.png">
                        </div>
                        <div class="pay_way_item canSelect" :class="{ active: paymentType == 'PC_WECHAT_PAY'}" @click="paymentType='PC_WECHAT_PAY'">
                            <img src=" https://resource.rcclchina.com.cn/tui2/order/wechartpay.png">
                        </div>
                    </div>
                </div>
                <div class="order_ft_con" style="margin-bottom: 10px;">
                    <div class="ft_lf">
                        <div class="unpaid_rg">
                            <span>
                                应付总计：
                                <span class="text">
                                    ￥
                                    <span id="netAmountText"> {{pageData.amount}}</span>
                                </span>
                            </span>

                        </div>
                    </div>
                    <div class="ft_rg" id="goToPay" @click="submitPayment">立即支付</div>
                </div>
            </div>
            <div v-else class="line_con choose_pay_con">
                <div class="line-intro">
                    <div class="pay_title">温馨提醒</div>
                    <div class="pay_text" v-html="campaign.campaignDescription">
                       
                    </div>
                </div>
            </div>
        </div>

         <OpenBookingRulePopup 
            :isShow="isShowRulePopup"
            v-on:onModalClose="isShowRulePopup=false"
            :rule="rule"
            :ruleTitle="ruleTitle"
        />
    </div>
</template>

<script>
import api from '@/api'
const OpenBookingRulePopup = () => import ('@/components/Booking/OpenBooking/OpenBookingRulePopup')
export default {
    name: "OpenBookingDetail",
    components: {
        OpenBookingRulePopup
    },
    data () {
        return {
            pageData: {},
            paymentType: "ALIPAY",
            isShowRulePopup: false
        }
    },
    beforeMount() {
        this.initPage()
    },
    mounted() {
       
    },
    beforeDestroy () {

    },
    methods: {
        async initPage () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return this.$router.push({ name: 'Login', query:{ 
                    returnUrl: encodeURIComponent(location.href)
                }})
            }

            const query = this.$router.currentRoute.query
            if (!query || !query.orderId || query.orderId == '') {
                return this.$router.push({ name: 'BookingListPage' })
            }

            const { success, data } = await api.booking.openBookingDetail({
                orderId: query.orderId,
                userName: userToken
            })
            if (!success) {
                return this.$router.push({ name: 'BookingListPage' })
            }
            this.pageData = data
        },
        async submitPayment() {

            this.$loading.show()
            const userToken = this.$store.state.user.userToken
            let paymentType = this.paymentType + ''
            const { success, data, errMsg } = await api.booking.openBookingSubmitPay({
                orderId: this.pageData.orderId,
                userName: userToken,
                payMethod: paymentType
            })
            this.$loading.hide()
            if (!success) {
                if (errMsg && errMsg.length > 0) {
                    this.$alert.show(errMsg)
                }
                return
            }
            if (data && data.paymentUrl && data.paymentUrl.length > 0) {
                if (this.paymentType == "PC_WECHAT_PAY") {
                    location.href = process.env.VUE_APP_BASE_URL + data.paymentUrl
                } else {
                    this.$router.push({
                        name: "OpenBookingPayByMethod",
                        params: {
                            paymentContent: {
                                checkoutShape: data.paymentUrl,
                                requestId: data.paymentId
                            },
                            paymentType: paymentType,
                            orderId: data.openBookingOrderId,
                            requestId: data.paymentId,
                            totalAmount: this.pageData.amount
                        }
                    })
                }
                
            }
        }
    },
    computed: {
        userInfo () {
            return this.$store.state.user.userInfo
        },
        paymentLink () {
            return { name: 'OpenBookingPay', query: { orderId: this.pageData.orderId} }
        },
        campaign () {
            return this.pageData.campaign || {}
        },
        rule () {
            if (!this.campaign.campaignTerms) return ""
            return this.campaign.campaignTerms
        },
        ruleTitle () {
            return this.campaign.campaignTermsTitle || ""
        },
        statusName () {
            if (this.pageData.openBookingStatus == 0) {
                return "未付款"
            } else if (this.pageData.openBookingStatus == 10) {
                return "已付款"
            } else if (this.pageData.openBookingStatus == 20) {
                return "已取消"
            } else if (this.pageData.openBookingStatus == 25) {
                return "已使用"
            }
            return ""
        },
        isExpired () {
            const openBookingEndDate = new Date(this.campaign.endDate.trim().substr(0,10))
            return openBookingEndDate < (new Date())
        },
        isSendGift () {
            return this.pageData.openBookingSendGift
            // return true
        },
        giftLink () {
            const giftLink = `${process.env.VUE_APP_REWARD_URL}/rewardpc/member/shop/gift`
            if (this.userInfo && this.userInfo.userIdentity == 1) {
                return `${giftLink}?token=${this.userInfo.localRewardToken}`
            } else {
                return `/Rccl.UserCenter/CustomerInfo/SignupReward?returnUrl=${encodeURIComponent(giftLink)}`
            }
        }
    }
}
</script>

<style lang="less" scoped>
.order_content {
    padding-bottom: 20px;
    .line_con {
        width: 100%;
        background-color: #fff;
        padding: 20px 20px 20px;
        overflow: hidden;
        border-top: 3px solid #e5f4ff;
        margin-bottom: 12px;
        .line_info_con {
            float: left;
            max-width: 625px;
            .ship_way {
                font-size: 22px;
                color: #282b2c;
                font-weight: 600;
                #opbkRuleLink {
                    color: #0073bb;
                    font-size: 12px;
                    cursor: pointer;
                    font-weight: 400;
                    span {
                        vertical-align: middle;
                        margin-right: 3px;
                    }
                    img {
                        position: relative;
                        top: -1px;
                    }
                }
            }
            .ship_time {
                font-size: 16px;
                color: #282b2c;
                padding: 5px 0px;
                line-height: 16px;
            }
        }
    }
    .order_con {
        margin-bottom: 10px;
        .order_info_con {
            background-color: #e5f4ff;
            padding: 8px 20px;
            color: #757575;
            overflow: hidden;
            .info_text {
                color: #000000;
            }
            .or_stu {
                display: inline-block;
                padding: 6px 22px;
                border-radius: 12px;
                font-size: 12px;
                line-height: 12px;
                margin-left: 15px;
                text-align: center;
            }
            .or_stu_unpay {
                background-color: #fbc500;
                color: #282b2c;
            }
            .or_stu_paid {
                background-color: #006ab9;
                color: #fff;
            }
            .go-gift {
                display: inline-block;
                vertical-align: middle;
                margin-left: 10px;
            }
        }
        .room_con {
            background-color: #fff;
            padding: 20px 20px 10px;
            .usr_con {
                overflow: hidden;
                margin-bottom: 10px;
                .usr_head_con {
                    overflow: hidden;
                    background-color: #f3f6f8;
                    border: solid 1px #d3dadd;
                    height: 40px;
                    .usr_head {
                        float: left;
                        padding-left: 20px;
                        line-height: 40px;
                        font-size: 20px;
                    }
                }
                .head_rg {
                    float: right;
                    width: 378px;
                    font-size: 20px;
                    line-height: 40px;
                }
                .info_con {
                    border: solid 1px #d3dadd;
                    border-top: none;
                    overflow: hidden;
                    padding: 20px 22px;
                    .info_lf {
                        float: left;
                        .det_lf {
                            float: left;
                            width: 206px;
                            font-size: 14px;
                            line-height: 24px;
                            color: #757575;
                            .text {
                                color: #282b2c;
                            }
                        }
                        .det_rg {
                            width: auto;
                        }
                    }
                    .info_rg {
                        float: right;
                        .price_con {
                            width: 378px;
                            padding-left: 20px;
                            border-left: 1px solid #d3dadd;
                            div {
                                width: 100%;
                                margin-bottom: 10px;
                                .text {
                                    float: right;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .choose_pay_con {
        .pay_title {
            font-size: 22px;
            font-weight: 400;
            color: #282b2c;
        }
        .pay_text {
            line-height: 20px;
            margin: 5px 0;
            color: #747d80;
        }
        .pay_way_con {
            overflow: hidden;
            margin-top: 15px;
            .pay_way_item {
                float: left;
                margin-right: 10px;
                width: 232px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                background-color: #ffffff;
                border: solid 1px #d3dadd;
                color: #006ab9;
                cursor: pointer;
            }
            .pay_way_item.active {
                border: solid 2px #fbc500;
            }
        }
    }

    .order_ft_con {
        overflow: hidden;
        background-color: #fff;
        .ft_lf {
            float: left;
            border-top: 1px solid #d3dadd;
            width: calc(100% - 216px);
            padding: 4px 10px;
            text-align: right;
            .unpaid_rg {
                float: right;
            }
            
            .text {
                font-size: 30px;
                color: #ff3022;
                font-weight: 400;
            }
            #netAmountText {
                font-weight: 600;
            }
        }
        .ft_rg {
            float: left;
            font-size: 18px;
            color: #282b2c;
            height: 52px;
            background-color: #fbc500;
            line-height: 52px;
            padding: 0 72px;
            cursor: pointer;
        }
    }

    .ft_12 {
        display: inline-block;
        font-size: 12px;
    }
    .fw-400 {
        font-weight: 400;
    }
}
</style>